export default "__VITE_ASSET__B9hM3tO3__"